import React, { useState,useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "../../../components/footer/Footer.js";
import TopButton from "../../../components/topButton/TopButton.js";
import "./Insurance.css";
import Navigationbar from "../../../components/header/Navigationbar.jsx";
import Model from "../../../containers/Model/Model.jsx";
import Paper from "@mui/material/Paper";
import Zoom from 'react-reveal/Zoom';
import WhatsAppCard from "../../contact/WhatsAppCard.jsx";

const Insurance = (props) => {
  const theme = props.theme;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isScrollingUp, setIsScrollingUp] = useState(true);
  const [animationShown, setAnimationShown] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleScroll = (event) => {
    setIsScrollingUp(event.deltaY < 0);
  };

  const handleTouchMove = (event) => {
    setIsScrollingUp(event.deltaY < 0);
  };
  useEffect(() => {
    if (isScrollingUp && !animationShown) {
      setAnimationShown(true);
    }

    window.addEventListener('wheel', handleScroll);
    window.addEventListener('touchmove', handleTouchMove);

    return () => {
      window.removeEventListener('wheel', handleScroll);
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, [isScrollingUp, animationShown]);
  return (
    <div className="educaton-main">
      <Navigationbar theme={theme} />
      <Paper elevation={4} style={{ width: "100%" }}>
        <div className="basic-education1">
          <Model open={isModalOpen} onClose={handleCloseModal} />
            <div className="basic-education-services">
              <div className="lifeinsurance">
              {isScrollingUp && animationShown ? (
                <> 
                  <div className="lifeinsurance-text">
                    <p className="lifeinsurance-text-header">Life Insurance</p>
                    <p className="lifeinsurance-text-main">
                      Life insurance is a financial product that provides a payout
                      to beneficiaries in the event of the policyholder's death. It
                      serves as a crucial tool for financial planning and risk
                      management, offering protection and financial security to
                      loved ones.
                    </p>
                    <p className="lifeinsurance-text-main">
                      Life insurance acts as a financial safety net for dependents,
                      helping to replace the policyholder's income and cover
                      expenses such as mortgages, education, and daily living costs.
                      Provides coverage for a specific term (e.g., 10, 20, or 30
                      years). It pays a death benefit if the policyholder passes
                      away during the term.Offers coverage for the entire lifetime
                      of the insured and includes a cash value component that grows
                      over time.
                    </p>
                  </div>
                </>
              ) : (
                <Zoom>
                  <div className="lifeinsurance-text">
                    <p className="lifeinsurance-text-header">Life Insurance</p>
                    <p className="lifeinsurance-text-main">
                      Life insurance is a financial product that provides a payout
                      to beneficiaries in the event of the policyholder's death. It
                      serves as a crucial tool for financial planning and risk
                      management, offering protection and financial security to
                      loved ones.
                    </p>
                    <p className="lifeinsurance-text-main">
                      Life insurance acts as a financial safety net for dependents,
                      helping to replace the policyholder's income and cover
                      expenses such as mortgages, education, and daily living costs.
                      Provides coverage for a specific term (e.g., 10, 20, or 30
                      years). It pays a death benefit if the policyholder passes
                      away during the term.Offers coverage for the entire lifetime
                      of the insured and includes a cash value component that grows
                      over time.
                    </p>
                  </div>
                </Zoom>
              )}
                {isScrollingUp && animationShown ? (
                  <>
                    <div className="lifeinsurance-card-main">
                      <div className="lifeinsurance-card">
                        <img
                          src='/assets/images/life-insurance.webp'
                          className="lifeinsurance-card-img-top"
                          alt="..."
                        />
                        <div className="lifeinsurance-card-body">
                          <h5
                            className="lifeinsurance-card-title"
                            style={{ paddingBottom: "5px" }}
                          >
                            Life Insurance
                          </h5>
                          <div
                            className="cardbutton"
                            style={{ display: "flex", gap: "20px" }}
                          >
                            <button
                              className="broking-applynow"
                              onClick={handleOpenModal}
                            >
                              Apply Now
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
              ) : (
                <Zoom>
                  <div className="lifeinsurance-card-main">
                    <div className="lifeinsurance-card">
                      <img
                        src='/assets/images/life-insurance.webp'
                        className="lifeinsurance-card-img-top"
                        alt="..."
                      />
                      <div className="lifeinsurance-card-body">
                        <h5
                          className="lifeinsurance-card-title"
                          style={{ paddingBottom: "5px" }}
                        >
                          Life Insurance
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Zoom>
              )}
              </div>
              <div className="nonlifeinsurance">
                {isScrollingUp && animationShown ? (
                  <> 
                    <div className="nonlifeinsurance-card-main">
                      <div className="nonlifeinsurance-card">
                        <img
                          src='/assets/images/881.jpg'
                          className="nonlifeinsurance-card-img-top"
                          alt="..."
                        />
                        <div className="nonlifeinsurance-card-body">
                          <h5
                            className="nonlifeinsurance-card-title"
                            style={{ paddingBottom: "5px" }}
                          >
                            Non Life Insurance
                          </h5>
                          <div
                            className="cardbutton"
                            style={{ display: "flex", gap: "20px" }}
                          >
                            <button
                              className="broking-applynow"
                              onClick={handleOpenModal}
                            >
                              Apply Now
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <Zoom>
                    <div className="nonlifeinsurance-card-main">
                      <div className="nonlifeinsurance-card">
                        <img
                          src="/assets/images/881.jpg"
                          className="nonlifeinsurance-card-img-top"
                          alt="..."
                        />
                        <div className="nonlifeinsurance-card-body">
                          <h5
                            className="nonlifeinsurance-card-title"
                            style={{ paddingBottom: "5px" }}
                          >
                            Non Life Insurance
                          </h5>
                          <div
                            className="cardbutton"
                            style={{ display: "flex", gap: "20px" }}
                          >
                            <button
                              className="broking-applynow"
                              onClick={handleOpenModal}
                            >
                              Apply Now
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Zoom>
                )}
                {isScrollingUp && animationShown ? (
                  <>
                    <div className="nonlifeinsurance-text">
                      <p className="nonlifeinsurance-text-header">
                        Non Life Insurance
                      </p>
                      <p className="nonlifeinsurance-text-main">
                        Non-life insurance, also known as property and casualty
                        insurance, provides coverage for a wide range of risks other
                        than those related to life and health. Non-life insurance
                        covers tangible assets such as property, vehicles, and goods.
                        It protects against financial losses arising from damage,
                        destruction, or loss of these assets due to unforeseen events.
                      </p>
                      <p className="nonlifeinsurance-text-main">
                        {" "}
                        Protects against damage or loss of physical property,
                        including homes, buildings, and belongings.Covers vehicles
                        against accidents, theft, and other damages.Provides
                        protection against legal liabilities for injuries or damage to
                        third parties. Travel Insurance: Offers coverage for
                        unexpected events during travel, such as trip cancellations,
                        medical emergencies, or lost luggage.
                      </p>
                    </div>
                  </>
                ) : (
                <Zoom>
                  <div className="nonlifeinsurance-text">
                    <p className="nonlifeinsurance-text-header">
                      Non Life Insurance
                    </p>
                    <p className="nonlifeinsurance-text-main">
                      Non-life insurance, also known as property and casualty
                      insurance, provides coverage for a wide range of risks other
                      than those related to life and health. Non-life insurance
                      covers tangible assets such as property, vehicles, and goods.
                      It protects against financial losses arising from damage,
                      destruction, or loss of these assets due to unforeseen events.
                    </p>
                    <p className="nonlifeinsurance-text-main">
                      {" "}
                      Protects against damage or loss of physical property,
                      including homes, buildings, and belongings.Covers vehicles
                      against accidents, theft, and other damages.Provides
                      protection against legal liabilities for injuries or damage to
                      third parties. Travel Insurance: Offers coverage for
                      unexpected events during travel, such as trip cancellations,
                      medical emergencies, or lost luggage.
                    </p>
                  </div>
                </Zoom>
                )}
              </div>
            </div>
        </div>
      </Paper>
      <Footer theme={props.theme} onToggle={props.onToggle} />
      <TopButton theme={props.theme} />
      <WhatsAppCard/>
    </div>
  );
};

export default Insurance;
